module.exports = __webpack_public_path__ + "img/receive-task.e1131038.svg";